import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
// import 'postcss-pxtorem'
import './assets/css/common.css'
import request from './api/request.js'
import store from './store'
import router from './router'

// import 'lib-flexible'
import echarts from 'echarts'
import cityInfo from './assets/js/cityInfo.json';
import cityInfo2 from './assets/js/cityInfo2.json';

Vue.prototype.$echarts = echarts
Vue.prototype.$request = request

import cSearch from './components/c-search.vue'
Vue.component('c-search',cSearch)
import cForm from './components/c-form.vue'
Vue.component('c-form',cForm)
import cInfo from './components/common-info.vue'
Vue.component('c-info',cInfo)


Vue.prototype.msgSuccess = function(msg) {
  this.$message({ showClose: true, message: msg, type: 'success' })
}

Vue.prototype.cityInfo = cityInfo
Vue.prototype.cityInfo2 = cityInfo2

Vue.prototype.landStateList = [
							{
								label : '闲置',
								value : 0,
							},
							{
								label : '自用',
								value : 1,
							},
							{
								label : '出租',
								value : 2,
							},
							{
								label : '出借',
								value : 3,
							},
							{
								label : '占用',
								value : 4,
							},
							{
								label : '其他',
								value : 5,
							},
						]

Vue.prototype.msgError = function(msg) {
  this.$message({ showClose: true, message: msg, type: 'error' })
}

Vue.prototype.msgInfo = function(msg) {
  this.$message.info(msg)
}

/** 权限指令,对按钮权限的控制 **/
const has = Vue.directive("has", {
  inserted: function(el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el);
    }
  },
});
// 权限检查方法（且把该方法添加到vue原型中）
Vue.prototype.$_has = function(value) {
  let isExist = false;
	let isAdmin = window.localStorage.getItem('USERADMIN')
	console.log(isAdmin)
  // 从浏览器缓存中获取权限数组（该数组在登入成功后拉取用户的权限信息时保存在浏览器的缓存中）
  var buttonpermsStr = window.localStorage.getItem('funcregList');
  if (buttonpermsStr == undefined || buttonpermsStr == null) {
    return false;
  }
  if (buttonpermsStr.indexOf(value) >= 0 || isAdmin == 'true') {
    // 若在按钮中定义的权限字段能在后端返回的权限数组中能找到，则该按钮可显示
    isExist = true;
  }
  return isExist;
};
export { has };

Vue.prototype.$routerBack = function(_this, url) {
	this.$store.state.visitedViews.forEach((item,index)=>{
	  if(item.path == _this.$route.path){
		this.$store.state.visitedViews.splice(index,1)
		this.$router.push(url)
		this.$store.state.activeView = url
	  }
  })
}

Vue.prototype.$addViews = function(name, path ,param) {
  let flag = false
  this.$store.state.visitedViews.forEach(res => {
  	if (res.path == path) {
  		flag = true
		this.$store.state.activeView = path
		console.log(path)
		if(param){
			  this.$router.push({ path: path, query: param});
		}else{
			this.$router.push(path)
		}
  	}
  })
  if (flag) {
  	return
  }
  //如果当前页面没有在路由池里面新增页面
  this.$store.state.visitedViews.push({
  	name: name,
  	path: path,
	param : param
  })
  this.$store.state.activeView = path
  if(param){
  	  this.$router.push({ path: path, query: param});
  }else{
  	this.$router.push(path)
  }
}

// router.beforeEach((to, from, next) => {
// 	var token = window.localStorage.getItem('TOKEN');
// 	if (to.path === '/login') {
// 	  next()
// 	}else{
// 		if(!token){
// 			next()
// 		}else{
// 			next(`/login`)
// 		}
// 	}
// })


Vue.use(ElementUI)

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
